import React from 'react';
import PropTypes from 'prop-types';
import { DropdownItem } from 'reactstrap';
import lodash from 'lodash';
import Icon from '../common/containers/icon';
import appHistory from '../../utils/appHistory';
const SidebarDirectFormNavItem = ({
  title,
  icon: _icon = 'plus-circle',
  directFormType,
  variant: _variant = 'nav',
  className: _className = '',
  renderControl: _renderControl = null,
  onCloseDrawer: _onCloseDrawer = () => {}
}) => {
  const handleClick = event => {
    if (event !== null && event !== void 0 && event.preventDefault) {
      event.preventDefault();
    }
    if (_onCloseDrawer) {
      _onCloseDrawer();
    }
    appHistory.push(`/directForms/new/${directFormType}`);
  };
  if (_variant === 'dropdown') {
    return /*#__PURE__*/React.createElement(DropdownItem, {
      className: _className.length > 0 ? _className : lodash.kebabCase(`mdi-${title}`),
      onClick: handleClick,
      tag: "button"
    }, _icon.length > 0 ? /*#__PURE__*/React.createElement(Icon, {
      glyph: _icon,
      style: {
        marginRight: '10px'
      }
    }) : null, title);
  }
  if (!_renderControl) {
    return null;
  }
  return /*#__PURE__*/React.createElement("li", {
    className: `global-nav-sidebar__item ${_className}`
  }, _renderControl({
    tag: 'button',
    icon: _icon,
    label: title,
    onClick: handleClick
  }));
};
SidebarDirectFormNavItem.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  directFormType: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['nav', 'dropdown']),
  className: PropTypes.string,
  renderControl: PropTypes.func,
  onCloseDrawer: PropTypes.func
};
export { SidebarDirectFormNavItem as TestSidebarDirectFormNavItem };
export default SidebarDirectFormNavItem;